import {
    strollersAddQuestionUrl,
    strollersAddReviewScoreUrl,
    strollersAddReviewUrl,
    strollersDetailUrl,
    strollersListUrl,
    strollersReviewsUrl,
    strollersReviewUrl,
    strollersSearchUrl,
    strollersUrl,
    strollersWishlistUrl,
} from 'mk2/apps/strollers/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [{
    app: 'strollers',
    exact: true,
    path: strollersUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/BrandsList/BrandsListPage' /* webpackChunkName: "strollers.BrandsList" */);
    },
    modules: [
        'mk2/apps/strollers/containers/BrandsList/BrandsListPage',
        'mk2/apps/strollers/containers/WishList/WishListPage',
    ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersSearchUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollersSearch/StrollersSearchPage' /* webpackChunkName: "strollers.StrollersSearch" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollersSearch/StrollersSearchPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersWishlistUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/WishList/WishListPage' /* webpackChunkName: "strollers.WishList" */);
    },
    modules: [ 'mk2/apps/strollers/containers/WishList/WishListPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersListUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersListPage' /* webpackChunkName: "strollers.BrandsStrollersList" */);
    },
    modules: [
        'mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersListPage',
        'mk2/apps/strollers/containers/WishList/WishListPage',
    ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersAddReviewUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage' /* webpackChunkName: "strollers.StrollerAddReview" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersAddReviewScoreUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage' /* webpackChunkName: "strollers.StrollerAddReview" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerAddReview/StrollerAddReviewPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersReviewUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerReview/StrollerReviewPage' /* webpackChunkName: "strollers.StrollerReview" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerReview/StrollerReviewPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersReviewsUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerReviews/StrollerReviewsPage' /* webpackChunkName: "strollers.StrollerReviews" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerReviews/StrollerReviewsPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersAddQuestionUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestionPage' /* webpackChunkName: "strollers.StrollerAddQuestion" */);
    },
    modules: [ 'mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestionPage' ],
}, {
    app: 'strollers',
    exact: true,
    path: strollersDetailUrl,
    getPage: () => {
        return import('mk2/apps/strollers/containers/StrollersDetail/StrollersDetailPage' /* webpackChunkName: "strollers.StrollersDetail" */);
    },
    modules: [
        'mk2/apps/strollers/containers/StrollersDetail/StrollersDetailPage',
        'mk2/apps/strollers/containers/WishList/WishListPage',
    ],
}];
